import SimulationEffectDateForm from './SimulationEffectDateForm.jsx';
import { compose } from 'ramda';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import { Loading } from '@fasstech/middle-design-system';
import useGetSimulationEffectDateQuery from './hooks/useGetSimulationEffectDateQuery.js';

const SimulationEffectDate = ({ getMiddleText }) => {
  const { getSimulationEffectDate, loading: isFetchingGetSimulationEffectDate } =
    useGetSimulationEffectDateQuery();

  if (isFetchingGetSimulationEffectDate) return <Loading />;

  return (
    <SimulationEffectDateForm
      getMiddleText={getMiddleText}
      getSimulationEffectDate={getSimulationEffectDate}
    />
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SimulationEffectDate);
